import React, { useState } from 'react'
import '../../../Assets/Css/EmpLeaveView.scss'
import { useLocation, useNavigate } from 'react-router-dom';
import UserAvatar from 'react-user-avatar';
import moment from 'moment';

const EmpLeaveView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data?.allData;

    const leaveStatus = data?.status;
    let statusColor;

    if (leaveStatus === 'Approved') {
        statusColor = 'rgb(0, 194, 146)';
    } else if (leaveStatus === 'Pending') {
        statusColor = '#f6b000';
    } else if (leaveStatus === 'Rejected') {
        statusColor = '#D21010';
    }

    const mainContent = <div className="empLeaveView-main">
        <div className="page-title">
            <h4> Leave </h4>
            <div className="edit-btn">
                <button
                    type="submit"
                    className="custom-btn"
                    onClick={() => navigate(-1)}
                >Cancel</button>
            </div>
        </div>
        <div className="content-part">
            <div className="row">
                <div className="col-lg-12">
                    <div className="left-part">
                        <div className="custom-row">
                            <div className="empleave-detail">
                                <h5> Leave Details </h5>
                                <h6 className='empleave-detail-divider'>Apply Date - {moment(data?.createdAt)?.format('DD-MM-YYYY hh:mm A')}</h6>
                                <div className="row">
                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className='labels'>Applicant Name</h6>
                                        </div>
                                        <div className="col-9">
                                            <div className="profile-section">
                                                {data?.user?.profile_pic ? (
                                                    <img src={`data:image/jpeg;base64,${btoa(
                                                        new Uint8Array(data?.user?.profile_pic?.data).reduce(
                                                            (data, byte) => data + String.fromCharCode(byte),
                                                            ''
                                                        )
                                                    )}`} alt="Profile Pic" className="profile-pic" />
                                                ) : (
                                                    <UserAvatar name={data?.user?.name || '--'} size={40} className='profile-pic' color="#5757fe" style={{ textTransform: 'uppercase', color: 'white' }} />
                                                )}
                                                <div className="profile-info">
                                                    <h6 className='labels'>{data?.user?.name}</h6>
                                                    <h6 className='labels'>{data?.user?.designation?.name}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className='labels'>Leave Date</h6>
                                        </div>
                                        <div className="col-9">
                                            <h6 className='labels'>{moment(data?.leave_date?.split(" ")?.[0])?.format('DD-MM-YYYY')}</h6>
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className='labels'>Leave Type</h6>
                                        </div>
                                        <div className="col-9">
                                            <div className="leaveType">
                                                <div className={`leaveType-background`}>
                                                    <h6 className={`leaveType-text`}>{data.casual > 0 ? "Casual Leave" : "Unpaid Leave"}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {data?.duration?.includes('Half') ? (
                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Duration</h6>
                                            </div>
                                            <div className="col-9 duration">
                                                <h6 className='labels'>Half Day</h6>
                                                <h6 className='half'>{data?.duration == 'firstHalf' ? 'First Half' : 'Second Half'}</h6>
                                            </div>
                                        </div>
                                    ) : (<></>)}


                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className='labels'>Reason For Absence</h6>
                                        </div>
                                        <div className="col-9">
                                            <h6 className='labels'>{data?.reason}</h6>
                                        </div>
                                    </div>

                                    <div className="input-groups">
                                        <div className="col-3">
                                            <h6 className='labels'>Status</h6>
                                        </div>
                                        <div className="col-9">
                                            <div className="leaveStatus">
                                                <div
                                                    className={`leaveStatus-circle ${data?.status}`}
                                                    style={{ backgroundColor: statusColor }}
                                                ></div>
                                                <h6
                                                    className={`leaveStatus-text ${data?.status}`}
                                                    style={{ color: statusColor }}
                                                >
                                                    {data?.status}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="input-groups">
                                    <div className="col-3">
                                        <h6 className='labels'>Actioned By</h6>
                                    </div>
                                    <div className="col-9">
                                        <div className="profile-section">
                                            {data?.user?.profile_pic ? (
                                                <img src={ProfilePic} alt="Profile Pic" className="profile-pic" />
                                            ) : (
                                                <UserAvatar name={data?.user?.name} size={40} className='profile-pic' />
                                            )}
                                            <div className="profile-info">
                                                <h6 className='labels'>{data?.user?.name}</h6>
                                                <h6 className='labels'>{data?.user?.designation?.name}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="input-groups">
                                    <div className="col-3">
                                        <h6 className='labels'>Actioned At</h6>
                                    </div>
                                    <div className="col-9">
                                        <h6 className='labels'>{moment(data?.createdAt)?.format('DD-MM-YYYY hh:mm A')}</h6>
                                    </div>
                                </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    return (
        <>
            {location?.pathname == "/leave/empleave/view" ? (
                <>
                    {mainContent}
                </>
            ) : (
                mainContent
            )}
        </>

    )
}

export default EmpLeaveView;